export default {
  data: [],
  instituicoes: [],
  info: {}
}
